import React from "react";
import Partner from "../../components/Partner";

const OurPartnersSec = (props) => {
  const { data } = props;
  const imageUrl = process.env.REACT_APP_IMAGE_URL;
  return (
    <>
      <Partner data={data} />
    </>
  );
};

export default OurPartnersSec;
